import { login } from '@/api/user'
import { getToken, setToken, removeToken } from '@/utils/auth'
import router, { resetRouter } from '@/router'
import { getAccount, setAccount } from '@/utils/account'

const Base64 = require('js-base64').Base64

const state = {
  token: getToken(),
  name: '',
  avatar: '',
  introduction: '',
  roles: [],
  userInfo: {},
  account: getAccount(), //登录账号密码
}

const getters = {
  //登录账号密码
  account: (state) =>
    state.account ? JSON.parse(Base64.decode(state.account)) : {},
}

const mutations = {
  SET_TOKEN: (state, token) => {
    state.token = token
    setToken(token)
  },
  SET_INTRODUCTION: (state, introduction) => {
    state.introduction = introduction
  },
  SET_NAME: (state, name) => {
    state.name = name
  },
  SET_AVATAR: (state, avatar) => {
    state.avatar = avatar
  },
  SET_ROLES: (state, roles) => {
    state.roles = roles
  },
  SET_USERINFO: (state, userInfo) => {
    state.userInfo = userInfo
  },
  /**
   * @description 保存登录账号密码
   * @param {*} state
   * @param {*} civilization_Info
   */
  set_account(state, account) {
    state.account = Base64.encode(JSON.stringify(account))
    setAccount(Base64.encode(JSON.stringify(account)))
  },
}

const actions = {
  // user login
  // 暂时提出 userInfo
  login({ commit }, userInfo) {
    const { account, password } = userInfo
    return new Promise((resolve, reject) => {
      login({ username: account.trim(), password: password })
        .then((response) => {
          const { data } = response
          commit('SET_TOKEN', data.token) //token
          commit('SET_USERINFO', data) // 存入个人信息
          commit('set_account', userInfo)
          resolve()
        })
        .catch((error) => {
          reject(error)
        })
    })
  },

  // get user info
  getInfo({ commit }) {
    commit('SET_ROLES', ['admin'])
    commit('SET_INTRODUCTION', '')
    return { roles: ['admin'] }
  },

  // user logout
  logout({ commit }) {
    commit('SET_TOKEN', '')
    commit('SET_ROLES', [])
    removeToken()
    resetRouter()
    router.push('/login')
    // reset visited views and cached views
    // to fixed https://github.com/PanJiaChen/vue-element-admin/issues/2485
    // resolve()
  },

  // remove token
  resetToken({ commit }) {
    return new Promise((resolve) => {
      commit('SET_TOKEN', '')
      commit('SET_ROLES', [])
      removeToken()
      resolve()
    })
  },

  // dynamically modify permissions
  async changeRoles({ commit, dispatch }, role) {
    const token = role + '-token'

    commit('SET_TOKEN', token)
    setToken(token)

    const { roles } = await dispatch('getInfo')

    resetRouter()

    // generate accessible routes map based on roles
    const accessRoutes = await dispatch('permission/generateRoutes', roles, {
      root: true,
    })
    // dynamically add accessible routes
    router.addRoutes(accessRoutes)
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}
